<template>
  <div class="help-center container">
    <HelpCenterModalVideo
      :opened="modalOpened"
      @closeModal="closeVideoTutorial"
    />
    <h1 class="help-center__page-title">
      Central de Ajuda
    </h1>
    <div class="help-center__wrapper">
      <div class="help-center__items">
        <div
          id="downloads"
          class="help-center__section"
        >
          <downloads />
        </div>
        <div
          id="cards"
          class="help-center__section"
        >
          <cards @openVideo="openVideoTutorial()" />
        </div>
        <div
          id="faq"
          class="help-center__section"
        >
          <faq />
        </div>
        <banner />
      </div>
      <div class="help-center__links">
        <ul ref="anchorsList">
          <li>
            <a
              class="help-center__anchor"
              href="#downloads"
            >Downloads</a>
          </li>
          <li>
            <a
              class="help-center__anchor"
              href="#cards"
            >Ajuda básica</a>
          </li>
          <li>
            <a
              class="help-center__anchor"
              href="#faq"
            >Perguntas frequentes</a>
          </li>
        </ul>
      </div>
    </div>
    <PageScrollTop />
  </div>
</template>

<script>
import SubHeader from '@/components/common/SubHeader'
import HelpCenterDownloads from './HelpCenterDownloads'
import HelpCenterCards from './HelpCenterCards'
import HelpCenterBanner from './HelpCenterBanner'
import HelpCenterFaq from './HelpCenterFaq'
import HelpCenterModalVideo from './HelpCenterModalVideo.vue'
import PageScrollTop from '@/components/common/PageScrollTop'

export default {
  name: 'HelpCenterMainView',
  components: {
    subheader: SubHeader,
    downloads: HelpCenterDownloads,
    faq: HelpCenterFaq,
    banner: HelpCenterBanner,
    cards: HelpCenterCards,
    HelpCenterModalVideo,
    PageScrollTop
  },
  data: () => {
    return {
      modalOpened: false
    }
  },
  computed: {
    sections() {
      return document.getElementsByClassName('help-center__section')
    }
  },
  mounted() {
    this.getScrollAndSetPosition()
    window.addEventListener('scroll', this.getScrollAndSetPosition)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.getScrollAndSetPosition)
  },
  methods: {
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Central de Ajuda',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    openVideoTutorial() {
      this.modalOpened = true
      this.openVideoTutorial('Vídeo Informativo')
    },
    closeVideoTutorial() {
      this.modalOpened = false
    },
    activeItemOnMenu(list, element) {
      list.forEach(el => {
        el.classList.remove('help-center__anchor--active')
      })
      element.classList.add('help-center__anchor--active')
    },
    getScrollAndSetPosition() {
      setTimeout(() => {
        const scroll = window.pageYOffset
        const endPage = document.documentElement.scrollHeight - document.documentElement.clientHeight - 150
        const anchors = this.$refs.anchorsList.getElementsByTagName('a')
        let currentElement = anchors[0]

        if (scroll >= endPage) {
          currentElement = anchors[anchors.length - 1]
        } else {
          this.sections.forEach((section, index) => {
            let sectionTop = section.offsetTop
            if (scroll > sectionTop - 90) currentElement = anchors[index]
          })
        }

        currentElement && this.activeItemOnMenu(anchors, currentElement)
      }, 400)
    }
  }
}
</script>

<style lang="scss">
.help-center {
  margin: 60px 0 60px 50px;
  padding: 50px 8%;
  position: relative;

  &:before {
    content: '';
    background-image: url('../../../static/images/help_symbol.svg');
    background-repeat: no-repeat;
    background-size: 350px;
    background-position: 102% 39%;
    width: 100%;
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: -1;
  }

  &__items {
    width: calc(100% - 170px);
  }
  &__links {
    position: fixed;
    top: 220px;
    right: 50px;
    width: 170px;

    li {
      margin: 0 !important;
    }
  }
  &__anchor {
    color: #7a7a7a !important;
    text-decoration: none;
    font-size: 14px;
    border-left: 2px solid #dadada;
    padding-left: 20px;
    height: 30px;
    display: flex;
    align-items: center;
    transition: all ease 0.2s;

    &--active {
      color: #7f1a54 !important;
      font-weight: 500;
      border-color: #7f1a54;
    }
  }
  &__section {
    margin-bottom: 50px;
    padding-bottom: 30px;
    padding-top: 90px;
    margin-top: -90px;
    border-bottom: 1px solid #d6d6d6;

    &:last-of-type {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
  &__page-title {
    font-weight: 700;
    font-size: 26px;
    color: #7a7a7a;
    margin-bottom: 40px;
  }
  &__title {
    font-weight: 500;
    font-size: 22px;
    line-height: 26px;
    color: #303030;
    letter-spacing: 0;
    margin-bottom: 25px;
    img {
      margin-right: 10px;
      margin-top: -2px;
    }
    p {
      font-weight: normal;
      font-size: 15px;
      line-height: 18px;
      letter-spacing: -0.321429px;
      display: block;
      margin-top: 15px;
    }
  }
  &__more-answer {
    align-items: center;
    text-align: right;
    a {
      color: #7f1a54 !important;
      text-decoration: none !important;
    }
  }
}
</style>
